<template>
  <textarea :name="name" :placeholder="placeholder" :value="value" />
</template>
<script>
  import 'src/assets/vendor/redactor/_scss/redactor.scss'
  import 'src/assets/vendor/redactor/redactor'
  import 'src/assets/vendor/redactor/_plugins/alignment/alignment'
  import 'src/assets/vendor/redactor/_plugins/variable/variable'
  import 'src/assets/vendor/redactor/_plugins/variable/variable.css'
  import 'src/assets/vendor/redactor/_plugins/fontsize/fontsize'
  import 'src/assets/vendor/redactor/_plugins/fontcolor/fontcolor'
  import 'src/assets/vendor/redactor/_plugins/imagemanager/imagemanager'
  import FileService from 'src/services/FileService'
  const UPLOAD_IMAGE_SIZES = {
    UPLOAD: 'upload',
    THUMB: 'thumb',
    SMALL: 'small',
    TINY: 'tiny'
  }

  const imageSizeOptions = [
    {
      label: 'Upload',
      value: UPLOAD_IMAGE_SIZES.UPLOAD
    },
    {
      label: 'Thumb',
      value: UPLOAD_IMAGE_SIZES.THUMB
    },
    {
      label: 'Small',
      value: UPLOAD_IMAGE_SIZES.SMALL
    },
    {
      label: 'Tiny',
      value: UPLOAD_IMAGE_SIZES.TINY
    }
  ]
  export default {
    name: 'redactor-wysiwyg',
    redactor: false,
    props: {
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      variables: {
        type: Array,
        default: () => []
      },
      config: {
        type: Object,
        default: () => ({
          plugins: ['alignment', 'fontcolor', 'fontsize', 'imagemanager'],
          imageResizable: true,
          imagePosition: true
        }),
      }
    },
    watch: {
      value(newValue) {
        if (this.redactor.editor.isFocus()){
          return
        }
        this.redactor.source.setCode(newValue)
      },
      variables(newVal) {
        if (newVal) {
          this.refreshInstance()
        }
      }
    },
    mounted() {
      this.init()
    },
    beforeDestroy() {
      window.$R(this.$el, 'destroy')
      this.redactor = null
    },
    methods: {
      getModifiedUrl(url, type) {
        const imageTypes = imageSizeOptions.map(o => o.value).join('|');
        // eslint-disable-next-line no-useless-escape
        const regex = new RegExp(`\/(${imageTypes})\/`);

        return url ? url.replace(regex, `/${type}/`) : '';
      },
      refreshInstance() {
        window.$R(this.$el, 'destroy')
        this.init()
        this.redactor.source.setCode(this.value)
      },
      init () {
        let callbacks = {
          changed: html => {
            this.handleInput(html)
            return html
          },
          blur: evt => {
            this.$emit('blur', evt)
          },
          focus: evt => {
            this.$emit('focus', evt)
          }
        };

        let config = {
          ...this.config,
          variables: this.variables,
          imageUpload: async (data, files, e, upload) => {
            if (!files || !files.length) {
              return ''
            }
            try {
              const file = files[0]
              const name = file.name.split('.')[0]
              const res = await FileService.uploadFile({file: file, name: name, public: true})
              const imgSrc = res.data.public_url
              upload.complete({
                file: {
                  url: imgSrc,
                  id: imgSrc
                }
              })
            } catch (e) {
              upload.complete({
                error: true,
                message: this.$t('html.editor.image.upload.error')
              })
            }
          }

        }
        if (this.variables && this.variables.length && !config.plugins.includes('variable')) {
          config.plugins.push('variable')
        }
        // extend config
        this.$set(config, 'callbacks', callbacks);

        // call Redactor
        this.redactor = window.$R(this.$el, config);

      },
      handleInput (val) {
        this.$emit('input', val);
      }
    }
  }
</script>
<style lang="scss">
  .redactor-styles {
    ul li::before {
      content: "•";
      @apply text-primary;
      display: inline-block;
      transform: translateX(-5px) translateY(0px);
      font-size: 20px;
    }
  }
</style>
